
/**
 * 강의 난이도
 */
export type GetCourseDetail200SummaryLevel = typeof GetCourseDetail200SummaryLevel[keyof typeof GetCourseDetail200SummaryLevel];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetCourseDetail200SummaryLevel = {
  BEGINNER: 'BEGINNER',
  INTERMEDIATE: 'INTERMEDIATE',
  ADVANCED: 'ADVANCED',
  ALL: 'ALL',
} as const;
